import axios from "axios";

class env {
  #envData: any;

  constructor() {}

  init(callback) {
    this.#envData = {
      AP_NAME: process.env.VUE_APP_AP_NAME,
      SC_RUL: process.env.VUE_APP_SC_URL,
      RECAPTCHA_SITEKEY: process.env.VUE_APP_RECAPTCHA_SITEKEY,
      NODE_ENV: process.env.NODE_ENV,
    };
    callback.bind(this)();
  }

  getData() {
    return this.#envData;
  }
}

export default env;
